import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
@Component({
  selector: "app-user-detail",
  templateUrl: "./user-detail.component.html",
  styleUrls: ["./user-detail.component.css"]
})
export class UserDetailComponent implements OnInit {
  userID:any;
  usersData:any=[];
  accessData:any = [];
  accessList = [
		{
			name: "Jobs",
			placeholder : [
				{title: "Create Job", key: "createJob", permission:0},
				{title: "View Team Member’s jobs", key: "viewTeamMemberJob", permission:0},
				{title: "Edit Team Member’s Jobs", key: "editTeamMemberJob", permission:0},
			]
		},
    {
			name: "Team",
			placeholder : [
				{title: "Add Team Member", key: "addTeamMember", permission:0},
				{title: "Edit Team Member", key: "editTeamMember", permission:0},
				{title: "Delete Team Member", key: "deleteTeamMember", permission:0},
			]
		},
    {
			name: "Licensing",
			placeholder : [
				{title: "View Active Plan and Inventory", key: "viewActivePlans", permission:0},
				{title: "View Invoice and Purchase History", key: "viewInvoice", permission:0},
				{title: "Buy Inventory", key: "buyInventory", permission:0},
        {title: "Cancel Subscriptions", key: "cancelSubscription", permission:0},
			]
		},
    {
			name: "Other Permissions",
			placeholder : [
				{title: "Dashboard", key: "dashboard", permission:0},
				{title: "Search", key: "search", permission:0},
				{title: "Messages", key: "messages", permission:0},
        {title: "Reports", key: "reports", permission:0},
        {title: "My Candidate", key: "myCandidate", permission:0},
			]
		},
  ] 

  constructor(public route: ActivatedRoute, private router: Router,private api: AdminService) { }

  ngOnInit(): void {
    this.userID = this.route.snapshot.paramMap.get("id")
    this.getDetails();
  }

  getDetails(){
    this.api.getData(apiUrl._usersDetail + "/" + this.userID, "")
      .subscribe(
        async (res) => {
          this.usersData = res.data;
          Object.entries(this.usersData.recruiter_group_permissions[0]).forEach(entry => {
            const [key, value] = entry
            for(let i=0; i< this.accessList.length;i++){
              for(let j = 0; j < this.accessList[i].placeholder.length; j++){
                if (key == this.accessList[i].placeholder[j].key && value == 1){
                  this.accessData.push({
                    "name":this.accessList[i].name,
                    "title":this.accessList[i].placeholder[j].title})
                }
              }
            }
          })
          const groupBy = (arr, key) => {
            const initialValue = {};
            return arr.reduce((acc, cval) => {
              const myAttribute = cval[key];
              acc[myAttribute] = [...(acc[myAttribute] || []), cval]
              return acc;
            }, initialValue);
          };
          const resp = groupBy(this.accessData, "name");
          this.accessData = [];
          for(let key in resp){
            this.accessData.push(resp[key])
          }
        },
        (err) => {
          console.log(err.error.message, "error");
        }
      );
  }

}